import { useNavigate } from "react-router-dom";
import { ReactComponent as LogoutIcon } from "../../../assets/svg/logoutIcon.svg";
import { useAuth } from "src/components/organisms/auth/auth-context";

interface ILogoutLinkButtonProps {
	disabled?: boolean; // Add the disabled prop
}

const LogoutLinkButton: React.FC<ILogoutLinkButtonProps> = ({
	disabled = false, // Default to false if not provided
}) => {
	const { logout } = useAuth();
	const navigate = useNavigate();

	const handleLogout = () => {
		logout();
		navigate("/login");
	};

	return (
		<div className="flex items-center justify-end gap-2">
			{/* <HyperLink href={""} onClick={logout} label={"logout"}></HyperLink> */}
			<a
				href={disabled ? undefined : ""} // Prevent navigation when disabled
				onClick={(e) => {
					if (disabled) {
						e.preventDefault(); // Prevent default click behavior
					} else {
						handleLogout(); // Call onClick only if not disabled
					}
				}}
				aria-disabled={disabled} // Accessibility support
				className={`font-Poppins font-semibold ${
					disabled
						? "text-gray-400 cursor-not-allowed" // Disabled styles
						: "text-blue-600 dark:text-blue-500 hover:text-orange-500 hover:underline"
				}`}
			>
				<div className="flex items-center gap-1 text-blue-600 hover:text-orange-500 hover:underline">
					<span className="font-semibold">Logout</span>
					<LogoutIcon className="w-4 h-4 font-semibold"></LogoutIcon>
				</div>
			</a>
		</div>
	);
};

export default LogoutLinkButton;
